import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { EntityStatus } from '../entity-status.type';
import { Entity } from '../entity.type';

const SupplierClassificationStatus = t.type(
  {
    category: nullable(Entity),
    status: nullable(EntityStatus),
  },
  'SupplierClassificationStatus',
);

type SupplierClassificationStatus = t.TypeOf<
  typeof SupplierClassificationStatus
>;
export { SupplierClassificationStatus };
